import type { OptimizationGroupProductGroupMapping } from '@/shared/generated'
import type { Selection } from '@/shared/lib/forest'
import type { ProductGroupsData } from '../lib/product-groups'

import { useCallback, useMemo } from 'react'

import { ForestPicker } from '@/shared/components/forest-picker'

import { selectionFromMapping, selectionToMapping } from '../lib/product-groups'

type ProductGroupsPickerProps = {
	data: ProductGroupsData
	value: OptimizationGroupProductGroupMapping[] | null | undefined
	onChange: (value: OptimizationGroupProductGroupMapping[]) => void
	disabled?: boolean
	testIdPrefix?: string
}

/** Form-facing picker: reads and writes the API `product_groups` mapping. */
export const ProductGroupsPicker = ({
	data,
	value,
	onChange,
	disabled,
	testIdPrefix = 'og-product-groups',
}: ProductGroupsPickerProps) => {
	const { pickerForest } = data
	const selection = useMemo(
		() => selectionFromMapping(pickerForest, value),
		[pickerForest, value]
	)
	const handleSelectionChange = useCallback(
		(next: Selection) => onChange(selectionToMapping(pickerForest, next)),
		[pickerForest, onChange]
	)

	return (
		<ForestPicker
			forest={pickerForest}
			selection={selection}
			onSelectionChange={handleSelectionChange}
			disabled={disabled}
			testIdPrefix={testIdPrefix}
		/>
	)
}
